import { render } from "./EndCustomers.vue?vue&type=template&id=dccb71a4"
import script from "./EndCustomers.vue?vue&type=script&lang=js"
export * from "./EndCustomers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__